import React from "react";

function SnapDataBox({
  class_name = "",
  title,
  value,
  subtext = "",
  total = false,
}) {
  return (
    <div className={`${total ? "total-snap-data-box" : "snap-data-box"}`}>
      <p className={`${total ? "total-snap-box-title" : "snap-box-title"}`}>
        {title}
      </p>
      <div
        className={`${total ? "total-snap-box-value-box" : "snap-box-value-box"}`}
      >
        <p
          className={`${total ? "total-snap-box-value" : "snap-box-value"} ${class_name}`}
        >
          {value}
        </p>
        <div className={`${total ? "total-snap-box-subtext" : "snap-box-subtext"}`}>
          {subtext}
        </div>
      </div>
    </div>
  );
}

export default SnapDataBox;
